module.exports = __webpack_public_path__ + "static/media/default_job_avatar.dfcc8d6e.svg";